<div id="error-notification" class="notification is-danger is-hidden">
  <button class="delete"></button>
  Wystąpił nieoczekiwany bład. Spróbuj ponownie za chwilę.
</div>

<router-outlet></router-outlet>
